import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqItems } from '../../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="w-full border-t border-rule bg-white" data-id="element-88" data-mp="252to4jdyfm1q">
      <div className="mx-auto grid max-w-shell gap-10 px-5 py-16 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.4fr)] lg:gap-20 lg:px-10 lg:py-24" data-id="element-89" data-mp="1v6gmmzc643wf">
        <SectionHeading eyebrow="COMMON QUESTIONS" heading="Answers before you choose a setup" id="faq-heading" data-id="element-90" data-mp="206cqmykv7vbz" />

        <div className="border-t border-rule" data-id="element-91" data-mp="1r4vefrakwdsk">
          {faqItems.map((item, i) => {
          const isOpen = openIndex === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <div key={item.question} className="border-b border-rule" data-id="element-92" data-mp="3lhl8qa4uzp0h" data-mpi={i}>
                <h3 data-id="element-93" data-mp="2nffq6vqnkndp">
                  <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : i)} className="flex min-h-[60px] w-full items-center justify-between gap-6 py-4 text-left" data-id="element-94" data-mp="2nempabedks3h">
                    <span className="font-display text-[17px] font-medium leading-snug text-navy" data-id="element-95" data-mp="24gjwdlipib0e">
                      {item.question}
                    </span>
                    <span aria-hidden="true" className="flex h-8 w-8 shrink-0 items-center justify-center border border-rule text-copper" data-id="element-96" data-mp="20hulbzl555jx">
                      {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-97" data-mp="3ptmwo3ml7ipa" /> : <PlusIcon className="h-4 w-4" data-id="element-98" data-mp="3kvutgdghsa5s" />}
                    </span>
                  </button>
                </h3>
                <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} className="pb-6 pr-10" data-id="element-99" data-mp="3svrg8cnqrow7">
                  <p className="rp-measure text-[14.5px] leading-[1.7] text-graphite/80" data-id="element-100" data-mp="5pi7w06ho780">
                    {item.answer}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}